module.exports = __webpack_public_path__ + "img/done.ba2e65c1.svg";